import './placeholder.css';
const Placeholder = ({width = 'auto', height = 'auto', round = 0}) => {

    return(
        <div className={'data-placeholder'} style={{width: width, height: height, borderRadius: round}}></div>
    )
}

export default Placeholder;
